export const getStoreGifts = state => state.storeGiftsState.storeGifts;
export const getLoading = state => state.storeGiftsState.isLoading;
export const getCreatedStatus = state => state.storeGiftsState.createdStatus;
export const getCreateGiftLoading = state => state.storeGiftsState.isCreateLoading;
export const getSingleStoreGift = state => state.storeGiftsState.singleStoreGift;
export const getBasketGifts = state => state.storeGiftsState.basketGifts;
export const getSingleGiftLoading = state => state.storeGiftsState.isGiftLoading;
export const getCreatedData = state => state.storeGiftsState.createdData;
export const getGiftPtinterStatus = state => state.storeGiftsState.printerStatus;